import script from "./BaseFeedback.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseFeedback.vue?vue&type=script&setup=true&lang=ts"

import "./BaseFeedback.vue?vue&type=style&index=0&id=107cbb88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-107cbb88"]])

export default __exports__